import React from 'react';
import { Card } from '../ui/Card';
import { AlertTriangleIcon, UserIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function RiskyClientsWidget() {
  // Dati di esempio per i clienti più rischiosi
  const riskyClients = [{
    id: '1',
    name: 'Retail Fashion Srl',
    riskScore: 4.8,
    importoScaduto: '€15.200',
    fattoriRischio: ['Pagamenti irregolari', 'Alto debito', 'Settore in crisi']
  }, {
    id: '2',
    name: 'Logistica Express Srl',
    riskScore: 4.5,
    importoScaduto: '€12.300',
    fattoriRischio: ['Ritardi frequenti', 'Comunicazione difficile']
  }, {
    id: '3',
    name: 'Edilizia Moderna Srl',
    riskScore: 4.2,
    importoScaduto: '€6.500',
    fattoriRischio: ['Settore in difficoltà', 'Liquidità ridotta']
  }, {
    id: '4',
    name: 'Industria Meccanica Srl',
    riskScore: 3.9,
    importoScaduto: '€8.750',
    fattoriRischio: ['Ritardi nei pagamenti', 'Problemi di produzione']
  }, {
    id: '5',
    name: 'Alimentari Freschi Spa',
    riskScore: 3.7,
    importoScaduto: '€1.800',
    fattoriRischio: ['Margini in calo', 'Concorrenza crescente']
  }];
  const getRiskColor = score => {
    if (score >= 4.5) return 'bg-red-100 text-red-800';
    if (score >= 4.0) return 'bg-orange-100 text-orange-800';
    if (score >= 3.5) return 'bg-yellow-100 text-yellow-800';
    return 'bg-green-100 text-green-800';
  };
  return <Card title="Top 5 Clienti a Rischio" data-id="element-649">
      <div className="space-y-4" data-id="element-650">
        {riskyClients.map(client => <div key={client.id} className="border-b border-gray-100 pb-4 last:border-0 last:pb-0" data-id="element-651">
            <div className="flex items-start justify-between" data-id="element-652">
              <div className="flex items-center" data-id="element-653">
                <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-654">
                  <UserIcon className="h-6 w-6 text-gray-500" data-id="element-655" />
                </div>
                <div data-id="element-656">
                  <h4 className="text-sm font-medium text-gray-900" data-id="element-657">
                    {client.name}
                  </h4>
                  <div className="flex items-center mt-1" data-id="element-658">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getRiskColor(client.riskScore)} mr-2`} data-id="element-659">
                      <AlertTriangleIcon className="h-3.5 w-3.5 mr-1" data-id="element-660" />
                      Rischio: {client.riskScore.toFixed(1)}
                    </span>
                    <span className="text-sm text-red-600 font-medium" data-id="element-661">
                      {client.importoScaduto}
                    </span>
                  </div>
                </div>
              </div>
              <Link to={`/clienti?id=${client.id}`} className="text-gray-400 hover:text-gray-600" data-id="element-662">
                <ChevronRightIcon className="h-5 w-5" data-id="element-663" />
              </Link>
            </div>
            <div className="mt-2 ml-13 pl-13" data-id="element-664">
              <div className="flex flex-wrap gap-1 ml-13" data-id="element-665">
                {client.fattoriRischio.map((fattore, index) => <span key={index} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800" data-id="element-666">
                    {fattore}
                  </span>)}
              </div>
            </div>
          </div>)}
      </div>
    </Card>;
}